module.exports = __webpack_public_path__ + "static/media/payment-option-credit-card.801c27b4.svg";